import OLD_DetailsRoute from "components/routes/OLD_flowsGroup/Flow/Details";

export const AsyncFlowDetailsPage = OLD_DetailsRoute;
